export default "__VITE_ASSET__1d7446a0__"